import { ThemeColors } from '../../../'

export interface CancelButtonColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
    Active: ThemeColors
  }
  FontColor: {
    Default: ThemeColors
    Active: ThemeColors
  }
}

export const cancelButtonColors: CancelButtonColors = {
  Background: {
    Default: {
      default: 'red.solid',
    },
    Hover: {
      default: 'red.emphasized',
    },
    Active: {
      default: 'red.emphasized',
    },
  },
  FontColor: {
    Default: {
      default: 'fg.inverted',
    },
    Active: {
      default: 'red.subtle',
    },
  },
}
